import { useCustomizationParams } from '../../context/ViewerContext';
import {
  ViewerAttributeInterface,
  ViewerGroupInterface,
  ViewerItemInterface,
  ViewerOptionInterface,
  ViewerStepInterface,
  instanceOfViewerGroupAttribute,
  instanceOfViewerGroupInput,
} from '../../core';
import { useExploded } from '../use-exploded';
import { useViewerOptions } from '../use-viewer-options';

const useSelectionHook = () => {
  const { isExploded, hasExploded, toggleExploded } = useExploded();
  const { customizationParams } = useCustomizationParams();
  const { onSelectedOption, onSelectedStep, onSelectedGroup, onSelectedAttribute, viewerOptions } = useViewerOptions();

  function checkExploded(options: string[] | undefined, id: string): void {
    if (hasExploded() && !!options) {
      if (options.indexOf(id) !== -1) {
        if (!isExploded) toggleExploded();
      } else if (isExploded) {
        toggleExploded();
      }
    }
  }

  function onSelectStep(item: ViewerStepInterface) {
    checkExploded(customizationParams?.explodedValues?.steps, item.id);
    onSelectedStep(item);
  }

  function onSelectOptions(item: ViewerItemInterface) {
    checkExploded(customizationParams?.explodedValues?.options, item.id);
    onSelectedOption(item);
  }

  function onSelectGroup(item: ViewerGroupInterface) {
    checkExploded(customizationParams?.explodedValues?.groups, item.id);
    onSelectedGroup(item);
  }

  function onSelectAttribute(item: ViewerAttributeInterface) {
    checkExploded(customizationParams?.explodedValues?.attributes, item.id);
    onSelectedAttribute(item);

    if (customizationParams?.selectOptionOnClick?.attributes) {
      const attributeFilter = customizationParams.selectOptionOnClick.attributes;
      attributeFilter.forEach((filter) => {
        if (filter.attributeIds.includes(item.id)) {
          filter.options.forEach((option) => {
            const optionToSelect = findOptionById(option);
            if (optionToSelect && !optionToSelect.selected) {
              onSelectOptions(optionToSelect);
            }
          });
        }
      });
    }
  }

  const findOptionById = (id: string): ViewerOptionInterface | undefined => {
    let option: ViewerOptionInterface | undefined = undefined;
    viewerOptions.groups.forEach((group) => {
      if (instanceOfViewerGroupInput(group)) {
        group.categoryOptions.forEach((opt) => {
          if (opt.id === id) {
            option = opt;
          }
        });
      } else if (instanceOfViewerGroupAttribute(group)) {
        group.attributes.forEach((attr) => {
          attr.options.forEach((opt) => {
            if (opt.id === id) {
              option = opt;
            }
          });
        });
      }
    });
    return option;
  };

  return {
    onSelectStep,
    onSelectOptions,
    onSelectGroup,
    onSelectAttribute,
  };
};

export default useSelectionHook;
